import React, { useState, useEffect } from 'react';
import { Button, Spinner } from 'reactstrap';
import useGlobal from '../../store';
import SuggestedRow from './SuggestedRow';


const UserSearch = (props) => {

    const [email, setEmail] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [searchresults, setSearchResults] = useState([]);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    const search = () => {
        console.log('search for this email:', email);
        setIsSearching(true);
        userActions.searchByEmail(email);
    }

    useEffect(() => {
        if(!response || response.type !== "searchbyemail") {
            return;
        }
        console.log('NEW SEARCH RESULTS', response);
        setIsSearching(false);
        setSearchResults(response.data);
    }, [response]);

    const searchList = searchresults.map(sr => <SuggestedRow key={sr.userID} giftlist={sr}></SuggestedRow>);

    return (
    <div className="kt-portlet kt-widget kt-widget--general-3 p-2">
        <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="form-group ">
                <div className="input-group">
                    <input type="text" className="form-control" placeholder="Full email address" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    <div className="input-group-append">
                        <Button color="primary" onClick={() => search()}>Go!</Button>
                    </div>
                </div>
            </div>
            
            <div>
                {isSearching ? <Spinner></Spinner> : <></>}
                {searchList ? searchList : <></>}
            </div>
        </div>
    </div>);
}

export default UserSearch;
